import { addYears } from 'utils/utils';
import { HotelRoom, Pax } from '../interfaces/BookResponse';

export class BookModel {
  passengers: PassengerModel[];

  constructor(paxes: Pax[], hotelRooms: HotelRoom[]) {
    this.passengers = paxes.map((pax: Pax) => new PassengerModel(pax, hotelRooms));
  }
}

export enum PaxHotelType {
  ADULT = 'ADT',
  CHILD = 'CNN',
}

export class PassengerModel {
  gender: string;
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  paxTypeCode: PaxHotelType;
  paxCode: number;
  dob?: Date;
  age?: number;
  isFirstGuest: boolean;
  roomIndex: number;
  title: string;
  passportNumber: string;
  passportValidTill: Date;
  phone2?: string;

  constructor(pax: Pax, hotelRooms: HotelRoom[]) {
    if (pax.paxTypeCode === PaxHotelType.CHILD) {
      const dob = new Date(pax.dob);
      this.age = new Date().getFullYear() - dob.getFullYear();
      this.gender = 'C';
      this.dob = addYears(this.age);
    } else {
      this.gender = pax.gender?.toUpperCase() || 'M';
    }

    this.roomIndex = 0;
    this.isFirstGuest = false;

    hotelRooms.forEach((room, index) => {
      if (room.paxCodes.includes(pax.paxCode)) {
        this.roomIndex = index;
      }
      if (room.paxCodes[0] === pax.paxCode) {
        this.isFirstGuest = true;
      }
    });

    this.paxTypeCode = pax.paxTypeCode;
    this.paxCode = pax.paxCode;

    this.firstName = pax.firstName || '';
    this.lastName = pax.lastName || '';
    this.phone = pax.phone || '';
    this.email = pax.email || '';
    this.title = pax.title || 'mr';
    this.dob = pax.dob ? new Date(pax.dob) : this.dob;
    this.passportNumber = pax.passportNumber || '';
    this.passportValidTill = pax.passportValidTill ? new Date(pax.passportValidTill) : new Date();
  }
}
